import { IReleaseNotes } from "@skills-app/models/release-notes";
import { EntityState, createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { ReleaseNotesPageActions, ReleaseNotesApiActions } from "../actions";

export interface State extends EntityState<IReleaseNotes> {
  ids: string[];
}

export const adapter: EntityAdapter<IReleaseNotes> =
  createEntityAdapter<IReleaseNotes>({
    selectId: (relaseNote: IReleaseNotes) => relaseNote.Id ?? "",
  });

export const initialState: State = adapter.getInitialState({
  ids: [],
});

export const reducer = createReducer(
  initialState,
  on(ReleaseNotesPageActions.notesAddedSuccess, (state, action) =>
    adapter.addMany(action.notes, state),
  ),
  on(ReleaseNotesPageActions.requestReleaseNotesPage, (state) =>
    adapter.removeAll({ ...state, ids: [] }),
  ),
  on(ReleaseNotesApiActions.updateReleaseNotesSuccess, (state, action) =>
    adapter.updateOne(action.releaseNote, state),
  ),
);

const { selectAll } = adapter.getSelectors();

export const selectAllShownReleaseNotes = selectAll;
